<section class="admin-page-grid">
  <div class="admin-panel-stack">
    <section class="admin-card">
      <div class="admin-card-head">
        <div>
          <div class="admin-eyebrow">Compagnies</div>
          <h2>Manager les compagnies</h2>
        </div>
        <button class="secondary-button" type="button" *ngIf="canManageCompanies()" (click)="startCreate()">
          Nouvelle compagnie
        </button>
      </div>

      <div class="admin-stats-grid admin-stats-grid--three">
        <article class="admin-stat-card">
          <span>Compagnies</span>
          <strong>{{ companies().length }}</strong>
          <small>Portefeuille visible</small>
        </article>
        <article class="admin-stat-card">
          <span>Licences vendues</span>
          <strong>{{ totalSeatCount() }}</strong>
          <small>{{ usedSeatCount() }} sieges actuellement consommes</small>
        </article>
        <article class="admin-stat-card">
          <span>MRR</span>
          <strong>{{ (overview()?.metrics?.monthlyRevenueEuros || 0) | currency: 'EUR' : 'symbol' : '1.0-0' : 'fr' }}</strong>
          <small>Montant mensuel estime</small>
        </article>
      </div>
    </section>

    <section class="admin-card" *ngIf="!canManageCompanies()">
      <div class="admin-lock-card">
        <div class="admin-eyebrow">Restriction</div>
        <h2>Gestion reservee au superadmin</h2>
        <p>
          Cette page reste visible pour garder la navigation coherente, mais seules les informations de votre scope sont consultables.
        </p>
      </div>
    </section>

    <section class="admin-card">
      <div class="admin-card-head">
        <div>
          <div class="admin-eyebrow">Catalogue</div>
          <h2>Liste des compagnies</h2>
        </div>
      </div>

      <div class="admin-feedback" *ngIf="feedback()" [class.success]="feedbackType() === 'success'" [class.error]="feedbackType() === 'error'">
        {{ feedback() }}
      </div>

      <div class="admin-table-wrap">
        <table class="admin-table">
          <thead>
            <tr>
              <th>Compagnie</th>
              <th>Plans</th>
              <th>Sieges</th>
              <th>Users</th>
              <th>MRR</th>
              <th>Contact</th>
              <th *ngIf="canManageCompanies()">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let company of companies(); trackBy: trackCompany">
              <td>
                <div class="admin-table-primary">{{ company.name }}</div>
                <div class="admin-table-secondary">{{ company.adminCount }} admins</div>
              </td>
              <td>
                <div class="admin-pill-list">
                  <span class="admin-badge" *ngFor="let planKey of company.selectedPlanKeys">{{ planKey }}</span>
                </div>
              </td>
              <td>
                <div class="admin-table-secondary" *ngFor="let plan of plans(); trackBy: trackPlan">
                  {{ plan.name }} {{ company.usedSeatsByPlan[plan.key] || 0 }}/{{ company.seatQuotaByPlan[plan.key] || 0 }}
                </div>
              </td>
              <td>
                <div class="admin-table-primary">{{ company.activeUsersCount }}</div>
                <div class="admin-table-secondary">{{ company.pendingInvites }} invitations</div>
              </td>
              <td>
                <div class="admin-table-primary">{{ company.monthlyTotalEuros | currency: 'EUR' : 'symbol' : '1.0-0' : 'fr' }}</div>
              </td>
              <td>
                <div class="admin-table-primary">{{ company.contact.firstName }} {{ company.contact.lastName }}</div>
                <div class="admin-table-secondary">{{ company.contact.email }}</div>
              </td>
              <td *ngIf="canManageCompanies()">
                <div class="admin-actions-cell">
                  <button class="secondary-button" type="button" (click)="editCompany(company)">Editer</button>
                  <button class="secondary-button" type="button" (click)="deleteCompany(company)" [disabled]="actionCompanyId() === company.id">
                    Supprimer
                  </button>
                </div>
              </td>
            </tr>

            <tr *ngIf="!companies().length">
              <td [attr.colspan]="canManageCompanies() ? 7 : 6" class="admin-empty-row">
                Aucune compagnie a afficher.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>

  <aside class="admin-card admin-form-card" *ngIf="canManageCompanies()">
    <div class="admin-card-head">
      <div>
        <div class="admin-eyebrow">{{ selectedCompanyId() ? 'Edition' : 'Creation' }}</div>
        <h2>{{ selectedCompanyId() ? 'Editer une compagnie' : 'Ajouter une compagnie' }}</h2>
      </div>
    </div>

    <form class="admin-form" [formGroup]="form" (ngSubmit)="submit()">
      <label class="admin-field">
        <span>Nom</span>
        <input type="text" formControlName="name" placeholder="Nom de la compagnie" />
      </label>

      <div class="admin-plan-grid">
        <article class="admin-plan-card" *ngFor="let plan of editablePlans(); trackBy: trackPlan">
          <label class="admin-checkbox">
            <input
              type="checkbox"
              [formControl]="planSelectionControl(plan.key)"
            />
            <span>{{ plan.name }}</span>
          </label>

          <div class="admin-table-secondary" *ngIf="isPlanInactive(plan.key)">Plan desactive</div>
          <div class="admin-table-secondary">{{ plan.displayPriceLabel || plan.monthlyPriceEuros }}</div>

          <label class="admin-field">
            <span>Quota {{ plan.key }}</span>
            <input
              type="number"
              min="0"
              [formControl]="seatQuotaControl(plan.key)"
            />
          </label>
        </article>
      </div>

      <label class="admin-field">
        <span>Contact prenom</span>
        <input type="text" formControlName="contactFirstName" />
      </label>

      <label class="admin-field">
        <span>Contact nom</span>
        <input type="text" formControlName="contactLastName" />
      </label>

      <label class="admin-field">
        <span>Contact email</span>
        <input type="email" formControlName="contactEmail" />
      </label>

      <label class="admin-field">
        <span>Telephone</span>
        <input type="text" formControlName="contactPhone" />
      </label>

      <label class="admin-field">
        <span>Poste</span>
        <input type="text" formControlName="contactJobTitle" />
      </label>

      <label class="admin-field">
        <span>Username contact</span>
        <input type="text" formControlName="contactUsername" />
      </label>

      <div class="admin-form-actions">
        <button class="primary-button" type="submit" [disabled]="saving()">
          {{ saving() ? 'Sauvegarde...' : selectedCompanyId() ? 'Mettre a jour' : 'Ajouter' }}
        </button>
        <button class="secondary-button" type="button" (click)="startCreate()">Reinitialiser</button>
      </div>
    </form>
  </aside>
</section>
